import { createSlice, isAnyOf } from "@reduxjs/toolkit"
import { Application } from "../../../../AdminPortal/scenes/Application/interface"
import { candidateRetrieveApplication } from "./CandidateApplicationAction"

interface ApplicationState {
  jobApplied: boolean | undefined
  remainingAttempts: Number | undefined
}

const initialState = {
  jobApplied: undefined,
  remainingAttempts: undefined
} as ApplicationState

const applicationSlicer = createSlice({
  name: 'candidate-application',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(candidateRetrieveApplication.fulfilled, (state: any, { payload }) => {
        state.jobApplied = payload.jobApplied
        state.remainingAttempts = Number(payload.remainingRetryCount)
      })
      .addCase(candidateRetrieveApplication.rejected, (state: any, { payload }) => {
        state.jobApplied = false
        state.remainingAttempts = undefined
      })
  },
})

export default applicationSlicer.reducer